'use client'

import { useRouter } from 'next/navigation'
import Link from 'next/link'
import React from 'react'
import { useInView } from 'react-intersection-observer'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import { Helmet } from 'react-helmet'
import { useSignUpMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'
import { TOAST_COSMETOLOG } from '../../../shared/constants/toastTypes'
import FormRegister from '@/entities/FormRegister'
import { submitForm } from '@/shared/actions/contact'
import { SITE_KEY_RECAPTCHA } from '@/shared/constants/linksApi'

export const RegistrationPage = () => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    const { userAuth: isAuth, setUser } = useGetIsAuthUser()
    const [signUp] = useSignUpMutation()
    const router = useRouter()
    const [recaptchaToken, setRecaptchaToken] = React.useState(null)

    // Проверка авторизации
    React.useEffect(() => {
        if (isAuth) {
            router.push('/my-account')
        }
    }, [isAuth, router])

    const signUpProfile = async (e, rememberDevice, token) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const formProps = Object.fromEntries(formData)

        if (!recaptchaToken) {
            TOAST_ERROR('Пройдите капчу!')
            return
        }
        
        try {
            const res = await submitForm(recaptchaToken)

            if (!res.success) {
                TOAST_ERROR(res.error)
                return
            }

            const result = await signUp(formProps).unwrap()
            if (result.error) {
                TOAST_ERROR(result.error)
                return
            }

            if (result.error) {
                TOAST_ERROR(result.error)
                return
            }
            
            if (result.result === 'success') {
                if (result.cosmetolog_message) {
                    TOAST_COSMETOLOG(result.cosmetolog_message)
                    router.push('/')
                    return
                }
                TOAST_SUCCESS('Вы успешно зарегистрировались!')
                setUser(result.data)
                router.push('/my-account')
            }
        } catch (err) {
            console.error('reCAPTCHA error:', err)
            TOAST_ERROR('Ошибка reCAPTCHA, попробуйте еще раз')
        }
    }

    return (
        <div
            ref={ref}
            className={`RegistrationPage ${
                inView && 'animate__animated animate__slideInLeft'
            }`}
        >
            <Helmet>
                <title>Регистрация</title>
            </Helmet>
            <h1>Регистрация</h1>
            <div className={'form-container'}>
                <FormRegister
                    textButton={'Зарегистрироваться'}
                    submitForm={signUpProfile}
                    setRecaptchaToken={setRecaptchaToken}
                />
                <span className={'redirect'}>
                    Есть аккаунт? <Link href={'/login'}>Войти</Link>
                </span>
            </div>
        </div>
    )
}
